import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { useTranslation } from "react-i18next";
import { REGEX_PHONEFIX } from "../../../../../../app/components/AppFooter/AppFooter";
import { useSettingsStore } from "../../../../../settings/services/useSettingsStore";
import "./LandingContact.css";

export function LandingContact() {
  const { t } = useTranslation();
  const settingsStore = useSettingsStore();

  const providerAddress = settingsStore.legacySettings?.providerAddress ?? "";
  const providerAddressLink =
    "https://www.google.com/maps/place/" + providerAddress.replace(/\s+/g, "+");

  const providerEmail = settingsStore.legacySettings?.providerEmail ?? "";
  const providerEmailLink = "mailto:" + providerEmail;

  const providerPhone = settingsStore.legacySettings?.providerPhone ?? "";
  const providerPhoneLink =
    "tel:" +
    settingsStore.legacySettings?.providerPhone?.replace(REGEX_PHONEFIX, "");

  return (
    <div className="landingContact">
      {(providerAddress || providerEmail || providerPhone) && (
        <Fieldset
          legend={t("Home.Contact")}
          className="shadow-5"
        >
          <div className="flex flex-column gap-2">
            {providerAddress && (
              <Button
                className="text-lg"
                label={providerAddress}
                link={true}
                icon="pi pi-directions"
                onClick={() => window.open(providerAddressLink, "_blank")}
              />
            )}

            {providerEmail && (
              <Button
                className="text-lg"
                label={providerEmail}
                link={true}
                icon="pi pi-envelope"
                onClick={() => window.open(providerEmailLink, "_blank")}
              />
            )}

            {providerPhone && (
              <Button
                className="text-lg"
                label={providerPhone}
                link={true}
                icon="pi pi-phone"
                onClick={() => window.open(providerPhoneLink, "_blank")}
              />
            )}
          </div>
        </Fieldset>
      )}
    </div>
  );
}
